import * as Types from './types';
import { Dispatch } from 'redux';
import {
  IAction,
  IActionMethods,
  KEEP_THE_SAME,
  StateStatus,
} from '../../../redux/utils/common';
import * as VatRateService from '../../../services/api/vat_rate';
import ModalActions from '../gl_modal_reducer/actions';
import { ModalIDs } from '../gl_modal_reducer/types';
import { getState } from '../../store';
import { ReducerKeys } from '../../reducers';

class FetchVatRateList implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_VAT_RATE_LIST,
      status: StateStatus.Pending,
      data: KEEP_THE_SAME,
    };
  }

  onSuccess(data: any): IAction {
    return {
      type: Types.SET_VAT_RATE_LIST,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_VAT_RATE_LIST,
      status: StateStatus.Failed,
      data: KEEP_THE_SAME,
    };
  }

  action(payload: VatRateService.IVatRateListInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await VatRateService.fetchVatRateList(payload);
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        dispatch(this.onFailed());
      }
    };
  }
}

type IUpdateVatRatePayload = VatRateService.IUpdateVatRateInput;
type IAddVatRatePayload = VatRateService.IAddVatRateInput;

class FetchVatRateTypes implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_VAT_RATE_TYPES,
      status: StateStatus.Pending,
      data: KEEP_THE_SAME,
    };
  }

  onSuccess(data: any): IAction {
    return {
      type: Types.SET_VAT_RATE_TYPES,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_VAT_RATE_TYPES,
      status: StateStatus.Failed,
      data: KEEP_THE_SAME,
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await VatRateService.fetchVatRateTypes();
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        dispatch(this.onFailed());
      }
    };
  }
}

class UpdateVatRate implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_UPDATE_VAT_RATE,
      status: StateStatus.Pending,
      data: {},
    };
  }

  onSuccess(): IAction {
    return {
      type: Types.SET_UPDATE_VAT_RATE,
      status: StateStatus.Success,
      data: {},
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_UPDATE_VAT_RATE,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: IUpdateVatRatePayload): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        await VatRateService.updateVatRate(payload);
        dispatch(this.onSuccess());
        dispatch(
          ModalActions.closeModalAction({ modalID: ModalIDs.MODAL_EDIT_VAT_RATE })
        );
        const state = getState(ReducerKeys.VAT_RATE_REDUCER).vatRateList.data;
        const paging = state?.paging;
        dispatch(
          new FetchVatRateList().action({
            sortField: 'vat_rate_id',
            page: paging?.page ?? 0,
            pageSize: paging?.pageSize ?? 25,
            order: 'asc',
          })
        );
      } catch (error: any) {
        dispatch(this.onFailed());
      }
    };
  }
}

class AddVatRate implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_ADD_VAT_RATE,
      status: StateStatus.Pending,
      data: {},
    };
  }

  onSuccess(): IAction {
    return {
      type: Types.SET_ADD_VAT_RATE,
      status: StateStatus.Success,
      data: {},
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_ADD_VAT_RATE,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: IAddVatRatePayload): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        await VatRateService.addVatRate(payload);
        dispatch(this.onSuccess());
        dispatch(
          ModalActions.closeModalAction({ modalID: ModalIDs.MODAL_ADD_VAT_RATE })
        );
        const state = getState(ReducerKeys.VAT_RATE_REDUCER).vatRateList.data;
        const paging = state?.paging;
        dispatch(
          new FetchVatRateList().action({
            sortField: 'vat_rate_id',
            page: paging?.page ?? 0,
            pageSize: paging?.pageSize ?? 25,
            order: 'asc',
          })
        );
      } catch (error: any) {
        dispatch(this.onFailed());
      }
    };
  }
}

export default {
  fetchVatRateListAction: (payload: VatRateService.IVatRateListInput) =>
    new FetchVatRateList().action(payload),
  fetchVatRateTypesAction: () => new FetchVatRateTypes().action(),
  updateVatRateAction: (payload: IUpdateVatRatePayload) =>
    new UpdateVatRate().action(payload),
  addVatRateAction: (payload: IAddVatRatePayload) =>
    new AddVatRate().action(payload),
};
